import React from 'react';
import { executeQuery } from "../../requests/executeQuery";
import {
    AGENT_COMMISSION_BREAKDOWN_PROCURED,
    AGENT_COMMISSION_BREAKDOWN_PAID,
    AGENT_COMMISSION_PAID, //c
    AGENT_COMMISSION_PROCURED,//c
    GET_YEARLY_TOTAL_COMMISSION
} from '../../consts/queries';
import PipelineTable from "../PipelineTable";
import Input from '../Input-new/Input';
import filter from "../../filter";
import { renderPrintFooter, removeDuplicateObjects, filterAgentsByDate, filterAgentsWithoutCommisionInTerminationYear } from "../../utils";
import { ApolloConsumer } from '@apollo/client';
import { GET_AGENT_COMMISSION_BREAKDOWN_PAID, GET_AGENT_COMMISSION_BREAKDOWN_PROCURED, GET_AGENT_COMMISSION_PAID, GET_AGENT_COMMISSION_PROCURED, GET_YEARLY_TOTAL_COMMISSIONS } from '../Graphql/Queries/agentCommissionBreakdown';
import { GetOldResponse } from '../ResponseConversion/GetOldResponse';
import { fetchData } from '../Service/graphQlService';
// import { GET_AGENT_COMMISSION_PAID, GET_AGENT_COMMISSION_PROCURED } from '../Graphql/Queries/propertiesQuery';

const cloneDeep = require('lodash.clonedeep');
const find = require('lodash.find');

const totalKey = 'Total';

function getColumns(year) {
    const prevYear = year - 1;
    return [{
        name: 'Agent',
        key: 'name',
        class: 'PipelineTable_align_left',
        hasLink: 'agent-pipeline',
    }, {
        name: 'Gross - Procured',
        key: 'grossProcured',
        format: '$',
        withCents: true,
        hasLink: 'agent-commission-procured',
        year: year
    }, {
        name: 'Gross - Paid',
        key: 'grossPaid',
        format: '$',
        withCents: true,
        hasLink: 'agent-commission-paid',
        year: year
    }, {
        name: 'Gross - Delta',
        key: 'delta',
        format: '$',
        withCents: true,
    }, {
        name: 'Net - Procured',
        key: 'netProcured',
        format: '$',
        withCents: true,
        //hasLink: 'agent-commission-procured',
        year: year
    }, {
        name: 'Net - Paid',
        key: 'netPaid',
        format: '$',
        withCents: true,
        //hasLink: 'agent-commission-paid',
        year: year
    }, {
        name: 'Net - Delta',
        key: 'netDelta',
        format: '$',
        withCents: true,
    }, {
        name: `Net - Delta ${prevYear}`,
        key: 'netPrevYear',
        format: '$',
        withCents: true,
    }, {
        name: 'Total',
        key: 'total',
        format: '$',
        withCents: true,
    }];
}

function compareDates(a, b) {
    const dateA = new Date(a.CLOSE_OF_ESCROW);
    const dateB = new Date(b.CLOSE_OF_ESCROW);
    return dateA - dateB;
}

const initializeRow = () => {
    return {
        id: 0,
        grossProcured: 0,
        grossPaid: 0,
        delta: 0,
        netProcured: 0,
        netPaid: 0,
        netDelta: 0,
        netPrevYear: 0,
        total: 0,

        prevYearTotal: 0,
    }
};

const findAgentRow = (rows, user) => {
    if (!rows || !rows.length) {
        return [];
    }
    let userFullName = user.lastName+user.firstName
    rows = rows.filter((row)=>(row.AGENT_LAST_NAME+row.AGENT_FIRST_NAME === userFullName));
    return rows;
};

export default class AgentCommissionBreakdown extends React.Component {
    static createOptionsWithoutOrder({ id, year }) {
        return {
            param: {
                ID: id,
                YEAR: year
            },
        };
    }
    constructor(props) {
        super(props);

        this.state = {
            query: {
                YEAR: new Date().getFullYear()
            },
            rows: {},
            subtitle: '',
            isPrint: false,
            loading: false,
        };
        this.client = null;
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.renderPrintDocument = this.renderPrintDocument.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.splitRowsToPages = this.splitRowsToPages.bind(this);
        this.token = localStorage.getItem('authToken');
    }

    static buildData(stateRows, data, pastYearData) {
        const rows = { ...stateRows };

        if (pastYearData)
            pastYearData.map(row => {
                let fullname = `${row.AGENT_LAST_NAME}${row.AGENT_FIRST_NAME}`;
                if (!rows[fullname])
                    rows[fullname] = initializeRow();
                if (!rows[fullname].id)
                    rows[fullname].id = row.AGENT_ID;
                if (!rows[fullname].name)
                    rows[fullname].name = row.AGENT_FIRST_NAME.charAt(0) + ". " + row.AGENT_LAST_NAME;//`${row.AGENT_FIRST_NAME} ${row.AGENT_LAST_NAME}`;
                if (!rows[fullname].lastName)
                    rows[fullname].lastName = row.AGENT_LAST_NAME;

                const grossPaid = row.PAID_GROSS_FEE ? parseFloat(row.PAID_GROSS_FEE) : 0;

                const listingProcuredGrossFee = row.LISTING_PROCURED_GROSS_FEE ? parseFloat(row.LISTING_PROCURED_GROSS_FEE) : 0;
                const buyingProcuredGrossFee = row.BUYING_PROCURED_GROSS_FEE ? parseFloat(row.BUYING_PROCURED_GROSS_FEE) : 0;
                const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
                const delta = grossPaid - totalProcuredGrossFee;

                const cumulativeNetDelta = row.prevYearTotal ? row.prevYearTotal : 0;

                rows[fullname].netPrevYear = Number(cumulativeNetDelta);// + delta / 2;               

                rows[fullname].netProcured = row.netProcured;
                rows[fullname].netPaid = row.netPaid;
                rows[fullname].netDelta = rows[fullname].netPaid - rows[fullname].netProcured;
            });

        data.map(row => {
            let fullname = `${row.AGENT_LAST_NAME}${row.AGENT_FIRST_NAME}`;
            if (!rows[fullname])
                rows[fullname] = initializeRow();
            if (!rows[fullname].id)
                rows[fullname].id = row.AGENT_ID;
            if (!rows[fullname].name)
                rows[fullname].name = row.AGENT_FIRST_NAME.charAt(0) + ". " + row.AGENT_LAST_NAME;
            if (!rows[fullname].lastName)
                rows[fullname].lastName = row.AGENT_LAST_NAME;

            rows[fullname].grossPaid = row.PAID_GROSS_FEE ? parseFloat(row.PAID_GROSS_FEE) : 0;

            const listingProcuredGrossFee = row.LISTING_PROCURED_GROSS_FEE ? parseFloat(row.LISTING_PROCURED_GROSS_FEE) : 0;
            const buyingProcuredGrossFee = row.BUYING_PROCURED_GROSS_FEE ? parseFloat(row.BUYING_PROCURED_GROSS_FEE) : 0;
            const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
            rows[fullname].grossProcured = totalProcuredGrossFee;

            rows[fullname].delta = rows[fullname].grossPaid - totalProcuredGrossFee;

            if (!rows[fullname].netPrevYear)
                rows[fullname].netPrevYear = 0;

            rows[fullname].total = rows[fullname].netCurrentYear + rows[fullname].netPrevYear;

            rows[fullname].netProcured = row.netProcured;
            rows[fullname].netPaid = row.netPaid;
            rows[fullname].netDelta = rows[fullname].netPaid - rows[fullname].netProcured;
            rows[fullname].total = rows[fullname].netDelta + rows[fullname].netPrevYear;
        });

        return rows;
    }

    static buildTotalData(stateRows) {
        const rows = { ...stateRows, [totalKey]: initializeRow() };

        Object.keys(rows[totalKey]).map(columnKey => {
            if (columnKey !== "id") {
                rows[totalKey][columnKey] = Object.keys(rows)
                    .reduce((previous, key) => previous + (typeof rows[key][columnKey] === 'string' ? parseFloat(rows[key][columnKey]) : rows[key][columnKey]), 0);
            }
        });

        return rows;
    }

    static mergeData(procuredData, paidData) {
        const data = cloneDeep(procuredData);

        data.forEach(agent => {
            const matchedAgent = find(paidData, { AGENT_ID: agent.AGENT_ID })
            if (matchedAgent)
                agent.PAID_GROSS_FEE = matchedAgent.PAID_GROSS_FEE;
        });

        return data;
    }

    beforePrint() {
        this.setState({ isPrint: true });
    }

    afterPrint() {
        this.setState({ isPrint: false });
    }
    static applyTrancheLogic(grossPaid, prevProcuredCumulative, grossCumulative, tranche, previousPercentage) {
        let newPercentage = previousPercentage + 0.05;
        if (prevProcuredCumulative < tranche) {
            if (grossPaid >= (tranche - prevProcuredCumulative)) {
                netProcured += (tranche - prevProcuredCumulative) * previousPercentage + (grossCumulative - tranche) * newPercentage;
                netPaid += (tranche - prevProcuredCumulative) * previousPercentage + (teamMemberGrossFee - (tranche - prevProcuredCumulative)) * newPercentage;
            } else {
                netProcured += (tranche - prevProcuredCumulative) * previousPercentage + (grossCumulative - tranche) * newPercentage;
                netPaid += (grossPaid - (grossCumulative - tranche)) * previousPercentage + (grossCumulative - tranche) * newPercentage;
            }
        } else {
            netProcured += totalProcuredGrossFee * newPercentage;
            netPaid += teamMemberGrossFee * newPercentage;
        }
    }
    /*  static async calculateNet1(data, query, year, prevYear, client) {
    
        for (const agent of data) {           
            
            var optionsYear = year === 0 ? prevYear : year;//options.param.YEAR;
            var optionsAgentId = agent.AGENT_ID;//options.param.AGENT_ID;
           
                
        const [res0Raw, res1Raw, res2Raw] = await Promise.all([
            fetchData(GET_AGENT_COMMISSION_PROCURED, { year: optionsYear, agentId: optionsAgentId }),
            fetchData(GET_AGENT_COMMISSION_PAID, { options: { year: optionsYear, agent_id: optionsAgentId } }),
            fetchData(GET_YEARLY_TOTAL_COMMISSIONS, { year: optionsYear, getYearlyTotalCommissionId: optionsAgentId })
        ]);
        if ( res0Raw && Array.isArray(res0Raw.data.agentCommissionProcured) &&
                res1Raw && Array.isArray(res1Raw.data.agentCommissionPaid) &&
                res2Raw && Array.isArray(res2Raw.data.getYearlyTotalCommission)) {
                let grossCumulative = 0;
                let netProcured = 0;
                let prevProcuredCumulative = 0;
                let netPaid = 0;
                let paidData = removeDuplicateObjects(res1Raw.data.agentCommissionPaid.filter(property => property.member_id === optionsAgentId));
                let map = new Map();

                res0Raw.data.agentCommissionProcured.forEach(item => {
                    map.set(item.arcimedes_row_id, item)
                });
                paidData.forEach(item => {
                    if (map.has(item.arcimedes_row_id)) {
                        let team_member_gross_fee = item.team_member_gross_fee;
                        map.set(item.arcimedes_row_id, { ...map.get(item.arcimedes_row_id), team_member_gross_fee });
                    } else {
                        map.set(item.arcimedes_row_id, item);
                    }
                });
                const mergedArray = Array.from(map.values());
                mergedArray.sort(compareDates);
                mergedArray.forEach((agentObj, index) => {
                    const listingProcuredGrossFee = agentObj.listing_gross_commission ? parseFloat(agentObj.listing_gross_commission) : 0;
                    const buyingProcuredGrossFee = agentObj.buying_gross_commission ? parseFloat(agentObj.buying_gross_commission) : 0;
                    const totalProcuredGrossFee =   agentObj.transaction_type === 'Extra Payment' ? 0 : listingProcuredGrossFee + buyingProcuredGrossFee;
        
                    let teamMemberGrossFee = agentObj.team_member_gross_fee ? parseFloat(agentObj.team_member_gross_fee) : 0;
                    grossCumulative += totalProcuredGrossFee;

                    if (grossCumulative <= 200000) {
                        netProcured += totalProcuredGrossFee * 0.5;
                        netPaid += teamMemberGrossFee * 0.5;
                    } else if (grossCumulative > 200000 && grossCumulative <= 400000) {
                        if (prevProcuredCumulative < 200000) {
                            if (teamMemberGrossFee >= (200000 - prevProcuredCumulative)) {
                                netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                netPaid += (200000 - prevProcuredCumulative) * 0.5 + (teamMemberGrossFee - (200000 - prevProcuredCumulative)) * 0.55;
                            } else {
                                netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 200000)) * 0.5 + (grossCumulative - 200000) * 0.55;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.55;
                            netPaid += teamMemberGrossFee * 0.55;
                        }
                    } else if (grossCumulative > 400000 && grossCumulative <= 600000) {
                        if (prevProcuredCumulative < 400000) {
                            if (teamMemberGrossFee >= (400000 - prevProcuredCumulative)) {
                                netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                netPaid += (400000 - prevProcuredCumulative) * 0.55 + (teamMemberGrossFee - (400000 - prevProcuredCumulative)) * 0.6;
                            } else {
                                netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 400000)) * 0.55 + (grossCumulative - 400000) * 0.6;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.6;
                            netPaid += teamMemberGrossFee * 0.6;
                        }
                    } else if (grossCumulative > 600000 && grossCumulative <= 800000) {
                        if (prevProcuredCumulative < 600000) {
                            if (teamMemberGrossFee >= (600000 - prevProcuredCumulative)) {
                                netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                netPaid += (600000 - prevProcuredCumulative) * 0.6 + (teamMemberGrossFee - (600000 - prevProcuredCumulative)) * 0.65;
                            } else {
                                netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 600000)) * 0.6 + (grossCumulative - 600000) * 0.65;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.65;
                            netPaid += teamMemberGrossFee * 0.65;
                        }
                    } else if (grossCumulative > 800000) {
                        if (prevProcuredCumulative < 800000) {
                            if (teamMemberGrossFee >= (800000 - prevProcuredCumulative)) {
                                netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                netPaid += (800000 - prevProcuredCumulative) * 0.65 + (teamMemberGrossFee - (800000 - prevProcuredCumulative)) * 0.7;
                            } else {
                                netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 800000)) * 0.65 + (grossCumulative - 800000) * 0.7;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.7;
                            netPaid += teamMemberGrossFee * 0.7;
                        }
                    }
                    prevProcuredCumulative = grossCumulative;
                });
                //let targetAgent = data.find(obj => obj.AGENT_ID === agent.AGENT_ID.toString())
                let targetAgent = data.find(obj => obj.AGENT_ID === agent.AGENT_ID)
                if (targetAgent) {
                    targetAgent['netProcured'] = netProcured;
                    targetAgent['netPaid'] = netPaid;
                    if (prevYear != 0) {
                        targetAgent['prevYearTotal'] = res2Raw.data && res2Raw.data.getYearlyTotalCommission[0] ? res2Raw.data.getYearlyTotalCommission[0].total : 0;
                    }

                }

            }

        }

        let cleanedData = filterAgentsWithoutCommisionInTerminationYear(data, year);

        return cleanedData;
    } */
    static async calculateNet(data, query, year, prevYear, client) {
       
        for (const agent of data) {           
            
            var optionsYear = year === 0 ? prevYear : year;//options.param.YEAR;
            var optionsAgentId = agent.AGENT_ID;//options.param.AGENT_ID;           
                
                    const [res0Raw, res1Raw, res2Raw] = await Promise.all([
                        fetchData(GET_AGENT_COMMISSION_PROCURED, { year: optionsYear, agentId: optionsAgentId }),
                        fetchData(GET_AGENT_COMMISSION_PAID, { options: { year: optionsYear, agent_id: optionsAgentId } }),
                        fetchData(GET_YEARLY_TOTAL_COMMISSIONS, { year: optionsYear, getYearlyTotalCommissionId: optionsAgentId })
                    ]);
    
                    const res0 = GetOldResponse(res0Raw).responses;
                    const res1 = GetOldResponse(res1Raw).responses;
                    const res2 = GetOldResponse(res2Raw).responses;

                    if ( res0[0] && res0[0].success && Array.isArray(res0[0].data) &&
                            res1[0] && res1[0].success && Array.isArray(res1[0].data) &&
                            res2[0] && res2[0].success && Array.isArray(res2[0].data)) {
                            let grossCumulative = 0;
                            let netProcured = 0;
                            let prevProcuredCumulative = 0;
                            let netPaid = 0;
                            let paidData = removeDuplicateObjects(res1[0].data.filter(property => property.MEMBER_ID === optionsAgentId));
                            let map = new Map();

                            res0[0].data.forEach(item => {
                                map.set(item.ARCIMEDES_ROW_ID, item)
                            });
                            paidData.forEach(item => {
                                if (map.has(item.ARCIMEDES_ROW_ID)) {
                                    let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                                    map.set(item.ARCIMEDES_ROW_ID, { ...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE });
                                } else {
                                    map.set(item.ARCIMEDES_ROW_ID, item);
                                }
                            });
                            const mergedArray = Array.from(map.values());
                            mergedArray.sort(compareDates);
                            mergedArray.forEach((agentObj, index) => {
                                const listingProcuredGrossFee = agentObj.LISTING_GROSS_COMMISSION ? parseFloat(agentObj.LISTING_GROSS_COMMISSION) : 0;
                                const buyingProcuredGrossFee = agentObj.BUYING_GROSS_COMMISSION ? parseFloat(agentObj.BUYING_GROSS_COMMISSION) : 0;
                                const totalProcuredGrossFee =   agentObj.TRANSACTION_TYPE === 'Extra Payment' ? 0 : listingProcuredGrossFee + buyingProcuredGrossFee;
                    
                                let teamMemberGrossFee = agentObj.TEAM_MEMBER_GROSS_FEE ? parseFloat(agentObj.TEAM_MEMBER_GROSS_FEE) : 0;
                                grossCumulative += totalProcuredGrossFee;

                                if (grossCumulative <= 200000) {
                                    netProcured += totalProcuredGrossFee * 0.5;
                                    netPaid += teamMemberGrossFee * 0.5;
                                    console.log(optionsAgentId,agentObj.NAME ,'200000',  netProcured, netPaid);
                                } else if (grossCumulative > 200000 && grossCumulative <= 400000) {
                                    if (prevProcuredCumulative < 200000) {
                                        if (teamMemberGrossFee >= (200000 - prevProcuredCumulative)) {
                                            netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                            netPaid += (200000 - prevProcuredCumulative) * 0.5 + (teamMemberGrossFee - (200000 - prevProcuredCumulative)) * 0.55;
                                            console.log(optionsAgentId,agentObj.NAME ,'200000-400000',  netProcured, netPaid);
                                        } else {
                                            netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                            netPaid += (teamMemberGrossFee - (grossCumulative - 200000)) * 0.5 + (grossCumulative - 200000) * 0.55;
                                            console.log(optionsAgentId,agentObj.NAME,'200000 else',  netProcured, netPaid);
                                        }
                                    } else {
                                        netProcured += totalProcuredGrossFee * 0.55;
                                        netPaid += teamMemberGrossFee * 0.55;
                                        console.log(optionsAgentId,agentObj.NAME,'200000 else2',  netProcured, netPaid);
                                    }
                                } else if (grossCumulative > 400000 && grossCumulative <= 600000) {
                                    if (prevProcuredCumulative < 400000) {
                                        if (teamMemberGrossFee >= (400000 - prevProcuredCumulative)) {
                                            netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                            netPaid += (400000 - prevProcuredCumulative) * 0.55 + (teamMemberGrossFee - (400000 - prevProcuredCumulative)) * 0.6;
                                        } else {
                                            netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                            netPaid += (teamMemberGrossFee - (grossCumulative - 400000)) * 0.55 + (grossCumulative - 400000) * 0.6;
                                        }
                                    } else {
                                        netProcured += totalProcuredGrossFee * 0.6;
                                        netPaid += teamMemberGrossFee * 0.6;
                                    }
                                } else if (grossCumulative > 600000 && grossCumulative <= 800000) {
                                    if (prevProcuredCumulative < 600000) {
                                        if (teamMemberGrossFee >= (600000 - prevProcuredCumulative)) {
                                            netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                            netPaid += (600000 - prevProcuredCumulative) * 0.6 + (teamMemberGrossFee - (600000 - prevProcuredCumulative)) * 0.65;
                                        } else {
                                            netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                            netPaid += (teamMemberGrossFee - (grossCumulative - 600000)) * 0.6 + (grossCumulative - 600000) * 0.65;
                                        }
                                    } else {
                                        netProcured += totalProcuredGrossFee * 0.65;
                                        netPaid += teamMemberGrossFee * 0.65;
                                    }
                                } else if (grossCumulative > 800000) {
                                    if (prevProcuredCumulative < 800000) {
                                        if (teamMemberGrossFee >= (800000 - prevProcuredCumulative)) {
                                            netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                            netPaid += (800000 - prevProcuredCumulative) * 0.65 + (teamMemberGrossFee - (800000 - prevProcuredCumulative)) * 0.7;
                                        } else {
                                            netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                            netPaid += (teamMemberGrossFee - (grossCumulative - 800000)) * 0.65 + (grossCumulative - 800000) * 0.7;
                                        }
                                    } else {
                                        netProcured += totalProcuredGrossFee * 0.7;
                                        netPaid += teamMemberGrossFee * 0.7;
                                    }
                                }
                                prevProcuredCumulative = grossCumulative;
                            });
                            //let targetAgent = data.find(obj => obj.AGENT_ID === agent.AGENT_ID.toString())
                            let targetAgent = data.find(obj => obj.AGENT_ID === agent.AGENT_ID)
                            if (targetAgent) {
                                targetAgent['netProcured'] = netProcured;
                                targetAgent['netPaid'] = netPaid;
                                if (prevYear != 0) {
                                    targetAgent['prevYearTotal'] = res2[0].data && res2[0].data[0] ? res2[0].data[0].TOTAL : 0;
                                }

                            }

                        }
                        
                        
                    
           

        }

        let cleanedData = filterAgentsWithoutCommisionInTerminationYear(data, year);

        return cleanedData;
    }


    async updateToNetValues(data, pastYearData, query, year) {
        try {
            const [updatedData, updatedPastYearData] = await Promise.all([
                AgentCommissionBreakdown.calculateNet(data, query, year, 0),
                AgentCommissionBreakdown.calculateNet(pastYearData, query, 0, year - 1)
            ]);
    
            let rows = AgentCommissionBreakdown.buildData({}, updatedData, updatedPastYearData);
            if(Object.keys(rows).length!==0){
                rows = AgentCommissionBreakdown.buildTotalData(rows);
            }
            //rows = AgentCommissionBreakdown.buildTotalData(rows);
    
            this.setState({
                subtitle: year,
                rows,
                loading: false
            });
        } catch (error) {
            console.error('Error updating net values:', error);
            this.setState({ loading: false });
        }
    }
 
    fetch() {
        this.setState({ loading: true });
        const query = { ...this.state.query };
        const year = query.YEAR ? parseInt(query.YEAR, 10) : new Date().getFullYear();
        let q = {
            YEAR: year
        }
        const options = filter(q, 'agent-commission-break-down');
        if(this.client){
            Promise.all([                
                fetchData(GET_AGENT_COMMISSION_BREAKDOWN_PROCURED, {year: year}),
                fetchData( GET_AGENT_COMMISSION_BREAKDOWN_PAID, {year: year}),
                fetchData(GET_AGENT_COMMISSION_BREAKDOWN_PROCURED, {year: year - 1}),
                fetchData( GET_AGENT_COMMISSION_BREAKDOWN_PAID, {year: year - 1})
            ]).then(res => {
                const res0 = GetOldResponse(res[0]).responses;
                const res1 = GetOldResponse(res[1]).responses;
                const res2 = GetOldResponse(res[2]).responses;
                const res3 = GetOldResponse(res[3]).responses;
                
                if (res && res0[0] && res0[0].success && Array.isArray(res0[0].data) &&
                    res1[0] && res1[0].success && Array.isArray(res1[0].data) &&
                    res2[0] && res2[0].success && Array.isArray(res2[0].data) &&
                    res3[0] && res3[0].success && Array.isArray(res3[0].data)) {
                    const resp = res1[0].data.find((e) => e.AGENT_ID == 61);
                    if (resp) {
                        res0[0].data.push(resp);
                    }
                    const data = AgentCommissionBreakdown.mergeData(res0[0].data, res1[0].data);
                    const pastYearData = AgentCommissionBreakdown.mergeData(res2[0].data, res3[0].data);
    
                    /* if (this.props.isSeniorAgent) {
                        data = findAgentRow(data, this.props.userData.person);
                        pastYearData = findAgentRow(pastYearData, this.props.userData.person);
                    } */
                    const fliteredData = filterAgentsByDate(data, year);
                    const filteredPastYearData = filterAgentsByDate(pastYearData, year);
    
                    this.updateToNetValues(fliteredData, filteredPastYearData, query, year);
                }
            });
        }
        
    }

    onSubmit(e) {
        if (e.key === 'Enter') {
            this.fetch();
        }
    }

    componentDidMount() {
        this.fetch();
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    handleInputChange(e) {
        const key = e.currentTarget.name;
        let value = e.currentTarget.value;
        let query = { ...this.state.query };
        query[key] = value;
        this.setState({ query });
    }

    splitRowsToPages(rows, rowsPerPage) {
        const keys = Object.keys(rows);
        let allPages = [];
        let currentPage = {};

        keys.forEach((key, index) => {
            currentPage[key] = rows[key];
            if ((index + 1) % rowsPerPage === 0 || index === keys.length - 1) {
                allPages.push(currentPage);
                currentPage = {};
            }
        })
        return allPages;
    }

    renderPrintDocument(rows, columns, subtitle) {
        const allPages = this.splitRowsToPages(rows, 20);

        return (
            allPages.map((page, index) => (
                <div className='content' style={{ background: `url('${arc.path.media + 'Transaction_Background.png'}')` }}>
                    <div key={index} className='print-container' >
                        <div className='AgentCommissionBreakdown_header'>
                            <h3 className='AgentCommissionBreakdown_h3'>Agent Commission Breakdown</h3>
                            <h4 className='AgentCommissionBreakdown_h4'>{subtitle}</h4>
                        </div>
                        <PipelineTable className="table" rows={page} columns={columns} />
                    </div>
                    <div className='AgentCommissionBreakdown_footer'>
                        {renderPrintFooter(true)}
                    </div>
                    <div className='page-break'></div>

                </div>
            ))

        )
    }

    render() {
        const { rows, query, subtitle, isPrint, loading } = this.state;
        const columns = getColumns(subtitle);

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client
                    }
                    return (
            <div className='AgentCommissionBreakdown'>
                {(!isPrint && <div className='title-row'><div className='AgentCommissionBreakdown_header'>
                    <div className="year-input">
                        <Input
                            name='YEAR'
                            label='YEAR'
                            data={query}
                            value={query.YEAR}
                            onChange={this.handleInputChange}
                            onKeyUp={this.onSubmit}
                            viewMode={loading}
                        />
                    </div>
                    <h3 className='AgentCommissionBreakdown_h3'>Agent Commission Breakdown</h3>
                    <h4 className='AgentCommissionBreakdown_h4'>{subtitle}</h4>
                </div></div>)}
                {loading ? <div className='loading'>Loading data...</div> :
                    !isPrint && <PipelineTable rows={rows} columns={columns} hasTotalRow className='list' linkInNewTab={true} hideSort={true} />}

                {isPrint && this.renderPrintDocument(rows, columns, subtitle)}
            </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}